import { useState } from 'react';
import { API_ENDPOINTS } from '../config/launchConfig';

const useLaunchData = () => {
    const [gamesList, setGamesList] = useState([]);
    const [filteredGamesList, setFilteredGamesList] = useState([]);
    const [marketList, setMarketList] = useState([]);
    const [lobbyList, setLobbyList] = useState([]);

    const fetchInitialData = async () => {
        try {
            const [gameInfoResponse, regulatedMarketResponse, lobbyResponse, gameFlexResponse] =
                await Promise.all([
                    fetch(API_ENDPOINTS.GAME_INFO).then((res) => res.json()),
                    fetch(API_ENDPOINTS.REGULATED_MARKET).then((res) => res.json()),
                    fetch(API_ENDPOINTS.LOBBY).then((res) => res.json()),
                    fetch(API_ENDPOINTS.GAMEFLEX_INFO).then((res) => res.json()),
                ]);

            // Map and merge data
            const mergedGames = gameInfoResponse
                .filter(game =>
                    // Filter out games with missing or empty critical fields
                    game.gameName && game.gameName.trim() !== '' &&
                    game.launchID && game.launchID.trim() !== ''
                )
                .map((game) => {
                    const match = gameFlexResponse.find(
                        (gf) => gf.LaunchCode && game.launchID &&
                            gf.LaunchCode.toLowerCase() === game.launchID.toLowerCase()
                    );
                    return {
                        ...game,
                        // Ensure game name is properly trimmed
                        gameName: game.gameName ? game.gameName.trim() : '',
                        GameflexGameID: match ? match.GameflexGameID : null,
                    };
                });

            setGamesList(mergedGames);
            setMarketList(regulatedMarketResponse);
            setLobbyList(lobbyResponse);

            return mergedGames;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };

    const filterGames = (games, mobileOnly, tabValue) => {
        if (!games || games.length === 0) return [];

        let filtered = games;

        if (mobileOnly !== null) {
            filtered = games.filter((game) => {
                // Handle null/undefined launch IDs
                if (!game.launchID) return false;

                const isDesktopGame = game.launchID.includes("Desktop");
                return mobileOnly ? !isDesktopGame : isDesktopGame;
            });
        }

        if (tabValue === 1) {
            filtered = filtered.filter((game) => game.GameflexGameID);
        }

        // Extra filter to ensure no blank entries slip through
        filtered = filtered.filter(game =>
            game &&
            game.gameName &&
            game.gameName.trim() !== '' &&
            game.launchID &&
            game.launchID.trim() !== ''
        );

        setFilteredGamesList(filtered);
    };

    return {
        gamesList,
        filteredGamesList,
        marketList,
        lobbyList,
        fetchInitialData,
        filterGames
    };
};

export default useLaunchData;